import AttachEntityModal from './AttachEntityModal'

export default AttachEntityModal
